<template>
  <div class="product__option" v-if="isPersonalize" :class="{hidden:isHideBlockCustomily}">
    <h2 v-if="isQrGreetingCardProductType">
      Personalization Of QR Greeting Card
    </h2>
    <h2 v-else>Personalization</h2>

    <p v-if="isProductTypeDigitalComicBook">
      The preview image you see is just a demo for you to adjust the image to
      fit. After you make a purchase, our artists will repaint it in a comic
      style to create the final version
    </p>
    <!-- Need to add class  product-form__variants here because Customily will idiotically find that class and append their options after it -->
    <div class="product-form__variants"></div>
    <div id="customily-options" ref="customilyOptions"></div>
    <sib-skeleton-loading
      class="product__preview-loading"
      height="100px"
    ></sib-skeleton-loading>
    <CustomPhotoAlbum v-if="isCustomPhotoAlbum && customilyDoneLoading" />

    <client-only>
      <slot></slot>
    </client-only>

    <client-only>
    <div class="customily-preview" v-if="!isCustomilyOptionsetOnly">
      <sib-button
        @click="showPreviewPopup"
        type="button"
        role="primary"
        class="button-show-preview mr-sm mb-sm"
        ref="buttonShowPreview"
        :data-intersect="PREVIEW_BUTTON"
      >
        {{
          isCustomPhotoAlbum ? 'Preview Page' : 'Preview Your Personalization'
        }}
      </sib-button>

      <sib-button
        v-if="isCustomPhotoAlbum"
        @click="showPreviewPopupPhotoAlbum"
        type="button"
        role="primary"
        class="button-show-preview"
      >
        Preview Book
      </sib-button>

      <client-only>
        <Teleport to="body">
          <div
            class="container sticky-button-show-preview-container"
            :class="{
              'sticky-button-show-preview-container--fixed':
                !isMainImageInViewPort && !isPreviewButtonInViewPort,
            }"
            v-if="shouldShowStickyPreviewButton"
          >
            <sib-button
              @click="showPreviewPopup"
              type="button"
              role="primary"
              size="md"
              width="full"
              class="sticky-button-show-preview"
              :loading="loadingStickyPreviewButton"
            >
              Preview Your Personalization
            </sib-button>
          </div>
        </Teleport>
      </client-only>
      <LightBoxPopup
        group="popup-preview"
        :contentId="popupID"
        @close="closePreviewPopup"
        ref="previewPopup"
      >
        <div
          class="product-popup-review__canvas-wrapper"
          ref="popupCanvasWrapper"
        >
          <div class="product-popup-preview__note">
            <p>Please check the preview carefully</p>
            <p>
              <em
                >Make sure the below customization is correct to receive your
                item faster</em
              >
            </p>
          </div>
          <div class="panzoom__viewport"></div>
          <div class="product-popup-review__button-wrapper my-md mx-md">
            <!-- Only show this button after preview button clicked to avoid Customily interacting with it -->
            <template
              v-if="
                !isDigitalContentProductType ||
                (isDigitalContentProductType && isQrGreetingCardNeedRemove)
              "
            >
              <sib-button
                role="primary"
                :disabled="checkingUrl"
                @click="clickAddToCartOnPreview"
                v-if="isButtonPreviewClicked"
              >
                {{
                  isQrGreetingCardProductType
                    ? 'Save and Continue to Customize Your Digital QR Content'
                    : 'Add To Cart'
                }}
              </sib-button>
            </template>
          </div>
          <RatePreviewAI />
        </div>
      </LightBoxPopup>

      <LightBoxPopup
        v-if="isCustomPhotoAlbum"
        group="popup-preview-photo-album"
        :contentId="'product-popup-preview-photo-album'"
        @close="closePreviewPopupPhotoAlbum"
        ref="previewPopupPhotoAlbum"
      >
        <div class="product-popup-review-photo-album__canvas-wrapper">
          <sib-carousel
            class="carousel-photo-album"
            v-if="mediaCampaignStore.photoAlbum.length"
            :key="mediaCampaignStore.photoAlbum.length"
            :items="
              mediaCampaignStore.photoAlbum.map((item) => ({
                image: {
                  src: item.image,
                  alt: '',
                  width: 800,
                  height: 800,
                },
              }))
            "
          >
          </sib-carousel>
          <div class="product-popup-review-photo-album__button-wrapper mt-sm">
            <!-- Only show this button after preview button clicked to avoid Customily interacting with it -->
            <template
              v-if="
                !isDigitalContentProductType ||
                (isDigitalContentProductType && isQrGreetingCardNeedRemove)
              "
            >
              <sib-button
                role="primary"
                :disabled="checkingUrl"
                @click="clickAddToCartOnPreview"
                v-if="isButtonPreviewClicked"
              >
                {{
                  isQrGreetingCardProductType
                    ? 'Save and Continue to Customize Your Digital QR Content'
                    : 'Add To Cart'
                }}
              </sib-button>
            </template>
          </div>
        </div>
      </LightBoxPopup>
    </div>
    </client-only>
    <CustomPeronalization
      v-if="isCustomBlogForm && customilyDoneLoading"
    ></CustomPeronalization>

    <div
      v-if="
        isCustomilyOptionsetOnly &&
        !isProductTypeHiddenNotice &&
        !isProductTagHiddenNotice
      "
      class="product-personalization-optionset-only-note mt-sm"
    >
      {{ productPersonalizationNoPreviewNote }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomPeronalization from './CustomPeronalization.vue'
import RatePreviewAI from './RatePreviewAI.vue'
import useProductStore from '@/store/product'
import useCustomizationStore from '@/store/customization'
import useSettingStore from '@/store/setting'
import { injectScript } from '@/utils/dom'
import {
  onMounted,
  watch,
  computed,
  onUnmounted,
  nextTick,
  ref,
  defineAsyncComponent,
} from 'vue'
import {
  getRawIdFromShopifyId,
  isPersonalizeProduct,
  isProductHasTags,
  isProductHasType,
  isProductHasTypeStartWith,
} from '@/utils/product'
import {
  PRODUCT_TAG_HIDE_BLOCK_CUSTOMILY,
  CUSTOMILY_CANVAS_WRAPPER_CLASS,
  CUSTOMILY_MODULE_EXPORT,
  CUSTOMILY_PREVIEW_CANVAS_ID,
  CUSTOMILY_SHOPIFY,
  debounce,
  EVENT_PRODUCT_SHOW_PREVIEW,
  EVENT_PRODUCT_UPDATE_MAIN_SLIDER,
  PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS,
  PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID,
  CUSTOMILY_CANVAS_CONTAINER_CLASS,
  EVENT_CUSTOMILY_START_LOADING,
  EVENT_CUSTOMILY_DONE_LOADING,
  CUSTOMILY_OPTION_LOADED_EVENT,
  EVENT_TRACKING_CUSTOMILY_START_LOADING,
  EVENT_TRACKING_CUSTOMILY_LOADED,
  EVENT_TRACKING_CUSTOMER_PERSONALIZED,
  TIME_MARK_CSR_LOAD_PAGE,
  TIME_MARK_CUSTOMILY_START_LOADING,
  MEASURE_NAME_CUSTOMILY_START_LOADING,
  TIME_MARK_CUSTOMILY_LOADED,
  TIME_MARK_CUSTOMER_PERSONALIZED,
  CSR_LOAD_TYPE,
  CUSTOMILY_OPTION_CHANGED_EVENT,
  EVENT_TRACKING_CUSTOMER_PREVIEW_PERSONALIZATION,
  MEASURE_NAME_CUSTOMILY_LOADED,
  MEASURE_NAME_CUSTOMER_PERSONALIZED,
  MEASURE_NAME_CUSTOMER_PREVIEW_PERSONALIZATION,
  QUERY_STRING_CUSTOMILY_CUSTOMIZATION_ID,
  CUSTOMILY_IMAGE_UPLOADED_EVENT,
  CUSTOMILY_LOADERS_HIDDEN_EVENT,
  CUSTOMILY_LOADERS_SHOWN_EVENT,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  EVENT_CUSTOM_UPLOAD_IMAGE,
  QUERY_STRING_GP_CUSTOM_DISABLE,
  PRODUCT_TYPE_QR_GREETING_CARD,
  PRODUCT_TYPE_DIGITAL_COMIC_BOOK,
  EVENT_CHECKING_URL,
  EVENT_FETCH_CUSTOMIZATION_TEMPLATES_BY_CODE,
  PRODUCT_TAG_CUSTOMILY_OPTIONSET_ONLY,
  PRODUCT_TAG_CUSTOM_PHOTO_ALBUM,
  STICKY_BUTTON_SHOW_PREVIEW_CONTAINER_CLASS,
  PRODUCT_TAG_HIDDEN_PREVIEW_NOTE,
  CACHE_KEY_CUSTOMILY_PERSONALIZED,
  EVENT_TRACKING_RESTORE_CUSTOMILY_PERSONALIZED,
  EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW,
  PRODUCT_TAG_CUSTOM_CROSS_WORDS,
  PRODUCT_TAG_CUSTOM_PHOTO_WORD,
  US_COUNTRY_CODE,
  OPTION_TYPE_SHIPPED_FROM,
} from '@/utils'
import Logger from '@/services/log'
import EventBus from '@/services/eventbus'
import type Button from '@/ui-kits/Button.vue'
import LightBoxPopup from '@/ui-kits/LightBoxPopup.vue'
import type { Panzoom as PanzoomType } from '@fancyapps/ui'
import useDeviceStore from '@/store/device'
import Analytics from '@/services/analytics'
import useRouteStore from '@/store/route'
import { useRoute } from 'vue-router'
import { useProductCustomization } from './composables/ProductCustomization'
import CustomPhotoAlbum from './CustomPhotoAlbum.vue'
import useMediaCampaignStore from '@/store/media'
import { useQrGreetingCardAndDigitalContent } from './composables/useQrGreetingCardAndDigitalContent'
import useRequestLocationStore from '@/store/requestLocation'
import { isOnServer } from '@/utils/ssr.js'

const emit = defineEmits<{
  (e: 'add-to-cart'): void
}>()

const { fetchCustomizationTemplates, appendCustomUploadImage, fetchCustomizationTemplatesByCode } =
  useProductCustomization()
const requestLocation = useRequestLocationStore()

const { checkQrGreetingaCardAndDigitalContent } =
  useQrGreetingCardAndDigitalContent()
const mediaCampaignStore = useMediaCampaignStore()
const route = useRoute()
const routeStore = useRouteStore()
const productStore = useProductStore()
const customizationStore = useCustomizationStore()
const settingStore = useSettingStore()
const deviceStore = useDeviceStore()
const waitTimeForPreviewRender = 500 // milisecond
const popupCanvasWrapper = ref<HTMLDivElement | null>(null)
const customilyOptions = ref<HTMLDivElement | null>(null)
let Panzoom: PanzoomType | null = null
let panzoomInstance: any = null
const popupID = 'product-popup-review'
let observer: IntersectionObserver | null = null
const buttonShowPreview = ref<typeof Button | null>(null)
const PRODUCT_MAIN_IMAGE = 'product-main-image'
const PREVIEW_BUTTON = 'preview-button'
const shouldShowStickyPreviewButton = ref(false)
const isMainImageInViewPort = ref(true)
const isPreviewButtonInViewPort = ref(false)
const previewPopup = ref<typeof LightBoxPopup | null>(null)
const previewPopupPhotoAlbum = ref<typeof LightBoxPopup | null>(null)
let isPersonalized = false
let waitingShowPreview = false
const isButtonPreviewClicked = ref(false)
const loadingStickyPreviewButton = ref(false)
const customilyDoneLoading = ref(false)
const checkingUrl = ref(false)

const rawProductId = ref('')
const confirmedRestoreCustomily = ref(false)
const customilyElmCheckbox = 'checkbox'
const customilyElmRadio = 'radio'
const customilyElmText = 'text'
const customilyElmSelect = 'select-one'
const customilyRefillModal = 'customily_personalized--popup_refill--modal'
const customilyRefillModalWrapper =
  'customily_personalized--popup_refill--modal_wrapper'
const customilyRefillButtonReject = 'customily_personalized--popup_btn--reject'
const customilyRefillButtonClose = 'customily_personalized--poup--close_svg'
const customilyRefillButtonConfirm =
  'customily_personalized--popup_btn--confirm'
const customilyOptionSelector = 'customily-options'

let initialInnerHeight = 0

const callbacks: {
  [key: string]: (a: boolean) => void
} = {
  [PRODUCT_MAIN_IMAGE]: (isShow: boolean) => {
    isMainImageInViewPort.value = isShow
  },
  [PREVIEW_BUTTON]: (isShow: boolean) => {
    isPreviewButtonInViewPort.value = isShow
  },
}

const isProductTypeDigitalComicBook = computed(() =>
  isProductHasType(productStore?.product, [PRODUCT_TYPE_DIGITAL_COMIC_BOOK])
)

const isQrGreetingCardProductType = computed(() => {
  return isProductHasType(productStore?.product, [
    PRODUCT_TYPE_QR_GREETING_CARD,
  ])
})

const isDigitalContentProductType = computed(() => {
  return isProductHasTypeStartWith(productStore?.product, 'digital')
})

const isPersonalize = computed(() => {
  return isPersonalizeProduct(
    productStore.product,
    settingStore.shop?.productTagPersonalize || ''
  )
})

const isCustomBlogForm = computed(() => {
  return isProductHasTags(productStore.product, [
    settingStore.shop?.productTagCustomBlogForm || '',
  ])
})

const isCustomStyleTransfer = computed(() =>
  isProductHasTags(productStore.product, [
    settingStore.shop?.productStyleTransferTag || '',
  ])
)
const isCustomFaceSwap = computed(() =>
  isProductHasTags(productStore.product, [
    settingStore.shop?.productFaceSwapTag || '',
  ])
)

const isCustomQrCodeSoundWave = computed(() =>
  isProductHasTags(productStore.product, [
    settingStore.shop?.productQrCodeSoundWave || '',
  ])
)

const isCustomCalendar = computed(() =>
  isProductHasTags(productStore.product, [
    settingStore.shop?.productTagCalendar || '',
  ])
)

const isCustomCrossWords = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_CUSTOM_CROSS_WORDS || ''])
)

const isCustomPhotoWord = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_CUSTOM_PHOTO_WORD || ''])
)

const isQueryCustomDisable = computed(
  () => route.query[QUERY_STRING_GP_CUSTOM_DISABLE]
)

const isCustomUpload = computed(
  () =>
    isCustomStyleTransfer.value ||
    isCustomFaceSwap.value ||
    isCustomQrCodeSoundWave.value ||
    isCustomCalendar.value ||
    isCustomCrossWords.value ||
    isCustomPhotoWord.value
)

const isCustomPhotoAlbum = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_CUSTOM_PHOTO_ALBUM])
)

const isCustomilyOptionsetOnly = computed(() =>
  isProductHasTags(productStore.product, [PRODUCT_TAG_CUSTOMILY_OPTIONSET_ONLY])
)

const productPersonalizationNoPreviewNote = computed(
  () => settingStore.shop?.productPersonalizationNoPreviewNote?.note || ''
)

const isProductTypeHiddenNotice = computed(() => {
  const productTypesHiddenNote =
    settingStore.shop?.productPersonalizationNoPreviewNote
      ?.productTypesHiddenNote || []
  return isProductHasType(productStore?.product, productTypesHiddenNote)
})

const isProductTagHiddenNotice = computed(() => {
  return isProductHasTags(productStore.product, [
    PRODUCT_TAG_HIDDEN_PREVIEW_NOTE || '',
  ])
})

const isQrGreetingCardNeedRemove = computed(() => {
  const lineItemsQrGreetingCardAndDigitalContent =
    checkQrGreetingaCardAndDigitalContent()
  if (lineItemsQrGreetingCardAndDigitalContent.length) {
    return lineItemsQrGreetingCardAndDigitalContent.find(
      (item) => item.type == PRODUCT_TYPE_QR_GREETING_CARD && item.isDelete
    )
  }
  return false
})

const isHideBlockCustomily = computed(() => {
  return isProductHasTags(productStore.product, [PRODUCT_TAG_HIDE_BLOCK_CUSTOMILY])
})

const customilyOptionChangedEvents = [
  CUSTOMILY_IMAGE_UPLOADED_EVENT,
  CUSTOMILY_OPTION_CHANGED_EVENT,
]

const customilyLoadersEvents = [
  CUSTOMILY_LOADERS_SHOWN_EVENT,
  CUSTOMILY_LOADERS_HIDDEN_EVENT,
]

const debounceMap = new Map<string, ReturnType<typeof setTimeout>>()

function debounceTextInputTrack(option: any) {
  const key = option.id || option.label || 'default'

  if (debounceMap.has(key)) clearTimeout(debounceMap.get(key))

  debounceMap.set(
    key,
    setTimeout(() => {
      if (!option.value) return

      Analytics.track('Input product page', {
        value: option.value,
        input_title: option.label,
        product_title: productStore?.product?.title,
        product_tags: productStore?.product?.tags,
        product_url: window.location.href,
      })

      debounceMap.delete(key)
    }, 800)
  )
}

onMounted(async () => {
  if (route.query[QUERY_STRING_CUSTOMILY_CUSTOMIZATION_ID]) {
    waitingShowPreview = true
  }
  watch(
    () => productStore.product?.id,
    (value) => {
      // because customily has error relate to window.meta so we neeed add line code to cover that error
      window.meta = { product: productStore.product }

      if (isPersonalize.value) {
        productStore.numberOfPersonalizedProductVisited++
      }
      if (value && isPersonalize.value) {
        import('@fancyapps/ui/src/Panzoom/Panzoom.scss')

        // inject jquery fallback customily can't download jquery
        injectScript(
          'https://code.jquery.com/jquery-2.2.4.min.js',
          undefined,
          true
        )

        EventBus.trigger(EVENT_CUSTOMILY_START_LOADING)
        if (
          !window[CUSTOMILY_MODULE_EXPORT] ||
          typeof window[CUSTOMILY_MODULE_EXPORT] !== 'function'
        ) {
          // inject customily script
          injectScript(
            'https://cdn.customily.com/customily.js',
            undefined,
            true
          )
          injectScript(
            'https://cdn.customily.com/shopify/static/customily.shopify.script.unified.js',
            undefined,
            true
          )
        } else {
          window[CUSTOMILY_MODULE_EXPORT]()
        }
      }
    },
    { immediate: true }
  )
  initCustomily()
  await fetchCustomizationTemplates()
  initGoldenphoenixCustom()

  EventBus.on(
    EVENT_CUSTOM_UPLOAD_IMAGE,
    (value) => (loadingStickyPreviewButton.value = value)
  )
  EventBus.on(EVENT_CHECKING_URL, (value) => {
    checkingUrl.value = value
  })

  // handle to hidden preivew button when use open the key board on mobile
  initialInnerHeight = window.innerHeight
  window.addEventListener('resize', handleStickyPreviewButton)

  watch(
    () => productStore.product?.id,
    (newValue, oldValue) => {
      if (newValue && newValue != oldValue) {
        const isRefillPopupCreated = document.querySelector(
          `.${customilyRefillModalWrapper}`
        )
        if (isRefillPopupCreated) return

        rawProductId.value = getRawIdFromShopifyId(newValue)

        // add event to save data personalized for elm customily
        document.body.addEventListener('change', addEventToRefillPersonalized)

        // show popup and handle refill data customily personalized
        startRefillCustomilyPersonalized()
      }
    },
    {
      immediate: true,
    }
  )

  watch(
    () => productStore.selectedVariant,
    async () => {
      if (isProductHasTags(productStore.product, ['AI_multi_pose'])) return
      if (isCustomStyleTransfer.value && customilyDoneLoading.value) {
        await nextTick()
        setTimeout(() => { appendCustomUploadImage() }, 200)
      }
  })

  EventBus.on(EVENT_FETCH_CUSTOMIZATION_TEMPLATES_BY_CODE, async (code) => {
    await fetchCustomizationTemplatesByCode(code)

    await nextTick()
    setTimeout(() => { appendCustomUploadImage() }, 200)
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', handleStickyPreviewButton)

  window.removeEventListener(
    CUSTOMILY_OPTION_LOADED_EVENT,
    customilyOptionsLoadedHandler
  )

  customilyOptionChangedEvents.forEach((event) => {
    window.removeEventListener(event, customilyOptionsChangedHandler)
  })

  customilyLoadersEvents.forEach((event) => {
    window.removeEventListener(event, customilyLoadersHandler)
  })

  if (isCustomUpload.value && !isQueryCustomDisable.value) {
    window.removeEventListener(
      CUSTOMILY_OPTION_LOADED_EVENT,
      appendCustomUploadImage
    )
    window.removeEventListener(
      CUSTOMILY_OPTION_CHANGED_EVENT,
      appendCustomUploadImage
    )
  }

  if (panzoomInstance) {
    panzoomInstance.destroy()
    panzoomInstance = null
  }

  const productPreviewSldie = document.getElementById(
    PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID
  )

  if (productPreviewSldie) {
    productPreviewSldie.innerHTML = ''
    productPreviewSldie.classList.remove(
      PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS
    )
  }

  productStore.productPreviewImage = null
  productStore.hasPreview = false
  customizationStore.styleTransfered = []
  customizationStore.faceSwapped = []
  mediaCampaignStore.photoAlbum = []

  window[CUSTOMILY_SHOPIFY] = null

  const canvasContainer = document.querySelector(
    `.${CUSTOMILY_CANVAS_WRAPPER_CLASS}`
  )

  if (canvasContainer) {
    canvasContainer.remove()
  }

  if (popupCanvasWrapper.value) {
    popupCanvasWrapper.value.innerHTML = ''
  }
  if (customilyOptions.value) {
    customilyOptions.value.innerHTML = ''
  }
  if (observer) {
    observer.disconnect()
  }

  document.body.removeEventListener('change', addEventToRefillPersonalized)

  try {
    debounceMap.forEach((timeout) => clearTimeout(timeout))
    debounceMap.clear()
  } catch (e) {
    console.log(e)
  }
})

function initGoldenphoenixCustom() {
  if (isCustomUpload.value && !isQueryCustomDisable.value) {
    window.addEventListener(
      CUSTOMILY_OPTION_LOADED_EVENT,
      appendCustomUploadImage
    )
    window.addEventListener(
      CUSTOMILY_OPTION_CHANGED_EVENT,
      appendCustomUploadImage
    )

    // fallback when customily don't send event customily-options-loaded
    appendCustomUploadImage()
  }
}

function initCustomily() {
  // trackingCustomilyStartLoading()

  window.addEventListener(
    CUSTOMILY_OPTION_LOADED_EVENT,
    customilyOptionsLoadedHandler
  )

  customilyOptionChangedEvents.forEach((event) => {
    window.addEventListener(event, customilyOptionsChangedHandler)
  })

  customilyLoadersEvents.forEach((event) => {
    window.addEventListener(event, customilyLoadersHandler)
  })

  window[CUSTOMILY_SHOPIFY] = {
    hooks: {
      canvas: {
        displayCanvas: debounce(customilyDisplayCanvas, 200),
      },
      onAppLoaded: function () {
        // trackingCustomilyLoaded()
        Logger.log('Customily', 'App loaded', 3)
      },
    },
  }
}

function customilyOptionsLoadedHandler() {
  EventBus.trigger(EVENT_CUSTOMILY_DONE_LOADING)
  checkShouldShowStickyPreviewButton()
  initStickyPreviewButton()
  customilyDoneLoading.value = true
}

async function customilyOptionsChangedHandler(event: any) {
  try {
    const option = event.detail?.option
    if (option?.type === 'Text Input') {
      debounceTextInputTrack(option)
    }
  } catch (e) {
    console.log(e)
  }
  // when an option changed, there are changes that other options will be appended
  // so we need to re-check if we want to show sticky preview button
  if (event.detail?.option?.type && event.detail.option.type != 'Text Input') {
    checkShouldShowStickyPreviewButton()
  }
  if (event.detail?.option?.is_textarea) {
    handleTextAreaOfCustomily()
  }
  waitingShowPreview = true
}





function handleTextAreaOfCustomily() {
  const textareas = document.getElementsByTagName('textarea')

  Array.from(textareas).forEach((textarea) => {
    const textareaTag = textarea as HTMLTextAreaElement

    textareaTag.style.height = 'auto'
    textareaTag.style.height = textareaTag.scrollHeight + 'px'
  })
}

function customilyLoadersHandler(event: Event) {
  if (event.type == CUSTOMILY_LOADERS_SHOWN_EVENT) {
    loadingStickyPreviewButton.value = true
  } else {
    loadingStickyPreviewButton.value = false
  }
}

function checkShouldShowStickyPreviewButton() {
  if (!deviceStore.isMobile || shouldShowStickyPreviewButton.value) return
  // wait a tick for customily options applied full style
  requestAnimationFrame(() => {
    if (customilyOptions.value) {
      const optionsHeight =
        customilyOptions.value.getBoundingClientRect().height
      // only toggling sticky button when the height of customily options bigger that 1/2 window height
      // because use usually start interacting with the element that reach the center line of the screen
      // so when the user start interacting with customily options, they should see the preview button
      const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800
      if (optionsHeight >= viewportHeight / 2) {
        shouldShowStickyPreviewButton.value = true
      }
    }
  })
}

function initStickyPreviewButton() {
  if (!deviceStore.isMobile) return
  const options = {
    root: null,
    threshold: 1,
  }
  observer = new IntersectionObserver(intersectCallback, options)
  const productMainSlider = document.getElementById('product__main-slider')

  if (productMainSlider) {
    productMainSlider.setAttribute('data-intersect', PRODUCT_MAIN_IMAGE)
    observer.observe(productMainSlider)
  }

  if (buttonShowPreview.value) {
    observer.observe(buttonShowPreview.value.$el)
  }
}

function intersectCallback(entries: IntersectionObserverEntry[]) {
  entries.forEach((entry) => {
    const dataIntersect = (entry.target as HTMLElement).dataset.intersect || ''
    const callback = callbacks[dataIntersect]
    if (!callback) return

    if (dataIntersect === PREVIEW_BUTTON) {
      const elementBoundingRect = entry.boundingClientRect
      // preview button is above the viewport
      // set its visible state to true to prevent showing the sticky button
      if (
        !entry.isIntersecting &&
        elementBoundingRect.top +
          elementBoundingRect.height -
          document.body.clientHeight <
          0
      ) {
        callback(true)
        return
      }
    }

    if (callback) {
      callback(entry.isIntersecting)
    }
  })
}

async function customilyDisplayCanvas() {
  if (isCustomilyOptionsetOnly.value) return
  appendPreviewToMainSlider()
  getPreviewImage()
  // trackingCustomerPersonalized()

  if (isProductHasTags(productStore.product, ['watermark'])) {
    if (!isOnServer) {
      if (!document.documentElement.style.getPropertyValue('--customily-watermark-image')) {
        const domain = window.location.hostname || window.location.host || 'hopesify.com'
        const capitalizedDomain = domain.charAt(0).toUpperCase() + domain.slice(1)
        const encodedDomain = encodeURIComponent(capitalizedDomain)
        const svg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Cstyle%3Etext %7B font-size: 22px; font-weight: bold; font-family: Arial, sans-serif; fill: rgba(0,0,0,0.13); text-anchor: middle; %7D%3C/style%3E%3Ctext transform='translate(75, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(225, 50) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(150, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(0, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3Ctext transform='translate(300, 150) rotate(-30)'%3E${encodedDomain}%3C/text%3E%3C/svg%3E")`
        document.documentElement.style.setProperty('--customily-watermark-image', svg)
      }
    }
    const canvasContainerEl = document.querySelector('.canvas-container')
    if (canvasContainerEl) {
      canvasContainerEl.classList.add('has-watermark')
    }
  }

  // only show preview when the customily option changed
  if (waitingShowPreview) {
    waitingShowPreview = false
    await nextTick()
    EventBus.trigger(EVENT_PRODUCT_SHOW_PREVIEW)
  }
}

function appendPreviewToMainSlider() {
  if (productStore.hasPreview == true) {
    return
  }
  // add preview canvas to main slider preview slide
  const canvasContainer = document.querySelector(
    `.${CUSTOMILY_CANVAS_WRAPPER_CLASS}`
  )
  const productPreviewSldie = document.getElementById(
    PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ID
  )
  if (!productPreviewSldie || !canvasContainer) return
  productPreviewSldie.appendChild(canvasContainer)
  productPreviewSldie.classList.add(
    PRODUCT_MAIN_SLIDER_PREVIEW_SLIDE_ACTIVE_CLASS
  )
  // trigger event to update main slider
  EventBus.trigger(EVENT_PRODUCT_UPDATE_MAIN_SLIDER)
  productStore.hasPreview = true
}

function getPreviewImage() {
  const previewCanvas = document.getElementById(
    CUSTOMILY_PREVIEW_CANVAS_ID
  ) as HTMLCanvasElement
  if (!previewCanvas) return

  // wait some time because we do not know when the fucking customily done render preview
  setTimeout(() => {
    productStore.productPreviewImage = previewCanvas.toDataURL()
  }, waitTimeForPreviewRender)
}

function showPreviewPopupPhotoAlbum() {
  if (loadingStickyPreviewButton.value) return
  isButtonPreviewClicked.value = true
  previewPopupPhotoAlbum.value?.show()
}

async function showPreviewPopup() {
  if (loadingStickyPreviewButton.value) return
  isButtonPreviewClicked.value = true
  try {
    Analytics.track('Preview clicked')
  } catch (e) {
    console.log(e)
  }
  previewPopup.value?.show()

  // wait to next frame for the wrapper get real width and height
  requestAnimationFrame(() => {
    const previewCanvas = document.getElementById(
      CUSTOMILY_PREVIEW_CANVAS_ID
    ) as HTMLCanvasElement
    if (!previewCanvas || !popupCanvasWrapper.value) return
    if (isProductHasTags(productStore.product, ['watermark'])) {
      popupCanvasWrapper.value.classList.add('has-watermark')
    }
    const panZoomViewport = popupCanvasWrapper.value.children[1] as HTMLElement
    if (!panZoomViewport) return

    const popupPreview = document.getElementById(popupID)
    if (!popupPreview) return

    const wrapperWidth = popupPreview.getBoundingClientRect().width

    // set initial width and height to the canvas element for it show big enough
    const maxWidth = Math.min(document.body.clientHeight * 0.85, wrapperWidth)
    const maxHeight = Math.min(wrapperWidth, document.body.clientHeight * 0.85)
    const width = Math.min(maxWidth, maxHeight)

    previewCanvas.style.width = width + 'px'
    previewCanvas.style.height = 'auto'
    previewCanvas.style.maxWidth = 'none'
    previewCanvas.style.maxHeight = 'none'
    // set a fixed height for the wrapper
    // so when the canvas is zoomed in, it will not bigger than the viewport
    popupCanvasWrapper.value.style.width = width + 'px'
    popupCanvasWrapper.value.style.height =
      width + (deviceStore.isMobile ? 250 : 0) + 'px'
    popupCanvasWrapper.value.style.margin = '0 auto'
    if (deviceStore.isMobile) {
      previewCanvas.style.minHeight = '300px'
    }


    panZoomViewport.appendChild(previewCanvas)
    // wait to next frame for the canvasn successfully added to the wrapper
    requestAnimationFrame(async () => {
      if (!Panzoom) {
        Panzoom = (await import('@fancyapps/ui')).Panzoom
      }
      previewCanvas.classList.add('panzoom__content')
      panzoomInstance = new Panzoom(popupCanvasWrapper.value, {
        width: width,
        height: width,
        maxScale: deviceStore.isMobile ? 3 : 2,
      })
    })
  })

  // trackingCustomerPreviewPersonalization()
}

function closePreviewPopupPhotoAlbum() {
  previewPopupPhotoAlbum.value?.close()
}

function closePreviewPopup() {
  if (panzoomInstance) {
    panzoomInstance.destroy()
    panzoomInstance = null
  }
  requestAnimationFrame(() => {
    // add preview canvas to main slider preview slide
    const canvasContainer = document.querySelector(
      `.${CUSTOMILY_CANVAS_CONTAINER_CLASS}`
    )
    const previewCanvas = document.getElementById(
      CUSTOMILY_PREVIEW_CANVAS_ID
    ) as HTMLCanvasElement
    if (!previewCanvas || !canvasContainer) return
    // set width height of the canvas back to normal
    previewCanvas.style.width = '100%'
    previewCanvas.style.height = 'auto'
    previewCanvas.style.transform = 'none'
    // these style ensure customily loader get the right width and height
    previewCanvas.style.maxWidth = ''
    previewCanvas.style.maxHeight = ''
    previewCanvas.style.transform = ''

    canvasContainer.insertBefore(previewCanvas, canvasContainer.firstChild)
  })
}

function handleStickyPreviewButton() {
  if (!deviceStore.isMobile) return
  const currentInnerHeight = window.innerHeight

  const stickyButtonPreviewContainer = document.querySelector(
    `.${STICKY_BUTTON_SHOW_PREVIEW_CONTAINER_CLASS}`
  )
  if (!stickyButtonPreviewContainer) return

  if (currentInnerHeight < initialInnerHeight) {
    stickyButtonPreviewContainer.style.display = 'none'
  } else {
    stickyButtonPreviewContainer.style.display = 'unset'
  }
  // Update the initial inner height for the next resize event
  initialInnerHeight = currentInnerHeight
}

function trackingCustomilyStartLoading() {
  performance.mark(TIME_MARK_CUSTOMILY_START_LOADING)

  const performanceTimeCustomilyStartLoading =
    routeStore.loadType == CSR_LOAD_TYPE
      ? performance.measure(
          MEASURE_NAME_CUSTOMILY_START_LOADING,
          TIME_MARK_CSR_LOAD_PAGE
        ).duration
      : performance.now()
  Analytics.track(
    EVENT_TRACKING_CUSTOMILY_START_LOADING,
    {
      performance_time: performanceTimeCustomilyStartLoading,
      handle: productStore.product?.handle,
      load_type: routeStore.loadType,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingCustomilyLoaded() {
  performance.mark(TIME_MARK_CUSTOMILY_LOADED)
  const performanceTimeCustomilyLoaded =
    routeStore.loadType == CSR_LOAD_TYPE
      ? performance.measure(
          MEASURE_NAME_CUSTOMILY_LOADED,
          TIME_MARK_CSR_LOAD_PAGE
        ).duration
      : performance.now()
  const selfTimeCustomilyLoaded = performance.measure(
    MEASURE_NAME_CUSTOMILY_LOADED,
    TIME_MARK_CUSTOMILY_START_LOADING
  ).duration

  Analytics.track(
    EVENT_TRACKING_CUSTOMILY_LOADED,
    {
      performance_time: performanceTimeCustomilyLoaded,
      self_time: selfTimeCustomilyLoaded,
      handle: productStore.product?.handle,
      load_type: routeStore.loadType,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingCustomerPersonalized() {
  isPersonalized = true
  performance.mark(TIME_MARK_CUSTOMER_PERSONALIZED)
  const performanceTimeCustomerPersonalize =
    routeStore.loadType == CSR_LOAD_TYPE
      ? performance.measure(
          MEASURE_NAME_CUSTOMER_PERSONALIZED,
          TIME_MARK_CSR_LOAD_PAGE
        ).duration
      : performance.now()
  const selfTimeCustomerPersonalized = performance.measure(
    MEASURE_NAME_CUSTOMER_PERSONALIZED,
    TIME_MARK_CUSTOMILY_LOADED
  ).duration

  Analytics.track(
    EVENT_TRACKING_CUSTOMER_PERSONALIZED,
    {
      performance_time: performanceTimeCustomerPersonalize,
      self_time: selfTimeCustomerPersonalized,
      handle: productStore.product?.handle,
      load_type: routeStore.loadType,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

function trackingCustomerPreviewPersonalization() {
  // if the user did personalize before use it as the time mark
  // if not use the time that customily loaded
  const startMark = isPersonalized
    ? TIME_MARK_CUSTOMER_PERSONALIZED
    : TIME_MARK_CUSTOMILY_LOADED
  const selfTimeCustomerPersonalized = performance.measure(
    MEASURE_NAME_CUSTOMER_PREVIEW_PERSONALIZATION,
    startMark
  ).duration

  Analytics.track(
    EVENT_TRACKING_CUSTOMER_PREVIEW_PERSONALIZATION,
    {
      self_time: selfTimeCustomerPersonalized,
      handle: productStore.product?.handle,
      user_personalized: isPersonalized,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

async function clickAddToCartOnPreview() {
  previewPopup.value?.close()
  await nextTick()

  emit('add-to-cart')
  EventBus.trigger(EVENT_CLICK_ADD_TO_CART_ON_POPUP_PREVIEW)
}

function trackingRestoreCustomilyPersonalized(action: string) {
  Analytics.track(
    EVENT_TRACKING_RESTORE_CUSTOMILY_PERSONALIZED,
    {
      action: action,
    },
    destinationIntegrations([MIXPANEL_DESTINATION])
  )
}

// refill customily personalize function
async function addEventToRefillPersonalized(event: any) {
  await nextTick()
  const productId = rawProductId.value
  if (
    event?.target?.closest(
      `#${customilyOptionSelector} input, #${customilyOptionSelector} select`
    ) &&
    !confirmedRestoreCustomily.value
  ) {
    lt(
      document.querySelectorAll(
        `#${customilyOptionSelector} input, #${customilyOptionSelector} select`
      ),
      productId
    )
  }
}

function ut(t: any, e: any, n: any) {
  return (
    e in t
      ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = n),
    t
  )
}

function st(t: any, e: any) {
  var n = Object.keys(t)
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t)
    e &&
      (r = r.filter(function (e2) {
        return Object.getOwnPropertyDescriptor(t, e2)?.enumerable
      })),
      n.push.apply(n, r)
  }
  return n
}

function ct(t: any) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}
    e % 2
      ? st(Object(n), !0).forEach(function (e2) {
          ut(t, e2, n[e2])
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
      : st(Object(n)).forEach(function (e2) {
          Object.defineProperty(t, e2, Object.getOwnPropertyDescriptor(n, e2))
        })
  }
  return t
}

function ft(t: any, e: any) {
  var n = JSON.parse(JSON.stringify(t))
  return (n = ct(
    ct({}, n),
    {},
    ut({}, e.id, {
      name: e.name,
      value: e.value,
    })
  ))
}

function lt(t: any, productId: any) {
  const e =
    JSON.parse(localStorage.getItem(CACHE_KEY_CUSTOMILY_PERSONALIZED)) || []
  const n = productId
  const eFiltered = e.filter((t2: any) => t2.product_id !== n)
  const run = function (t2: any, e2: any, n2: any) {
    const r = JSON.parse(JSON.stringify(t2))
    var i = {}
    n2.forEach(function (t3: any) {
      switch (t3.type) {
        case customilyElmCheckbox:
        case customilyElmRadio:
          if (!t3.checked) break
          i = ft(i, t3)
          break
        case customilyElmText:
        case customilyElmSelect:
          i = ft(i, t3)
      }
    }),
      r.push({
        product_id: e2,
        properties: i,
      }),
      localStorage.setItem(CACHE_KEY_CUSTOMILY_PERSONALIZED, JSON.stringify(r))
  }
  run(eFiltered, n, t)
}

function readingStoredOptions(prodId: string) {
  return JSON.parse(
    localStorage.getItem(CACHE_KEY_CUSTOMILY_PERSONALIZED) || '[]'
  ).find((i: any) => i.product_id == prodId)
}
function handleSingleRoundOfFillingOptions(ids: any) {
  for (let index = 0; index < ids.length; index += 1) {
    const element = ids[index],
      { elId: elementId, value } = element,
      existedEl = document.getElementById(elementId)
    if (existedEl) {
      const elType = existedEl.type
      elType == customilyElmRadio || elType == customilyElmCheckbox
        ? existedEl.click()
        : elType == customilyElmText
        ? (existedEl.setAttribute('value', value),
          existedEl.dispatchEvent(new Event('input')))
        : elType == customilyElmSelect
        ? ((existedEl.value = value),
          existedEl.dispatchEvent(new Event('change')))
        : ''
    }
  }
}

function handlePickedStoredOptions(ids: any) {
  for (let index = 0; index <= ids.length; index += 1)
    setTimeout(() => {
      handleSingleRoundOfFillingOptions(ids)
    }, 100)
}

function createPopup() {
  const el = document.createElement('div')
  el.className = customilyRefillModalWrapper

  const iconRefillPopup = `<svg height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 422.69 422.69" xml:space="preserve" fill="#38ba72" stroke="#38ba72" transform="matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_#c9dae1gCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#38ba72;" d="M211.343,422.686C94.812,422.686,0,327.882,0,211.343C0,94.812,94.812,0,211.343,0 s211.343,94.812,211.343,211.343C422.694,327.882,327.882,422.686,211.343,422.686z M211.343,16.257 c-107.565,0-195.086,87.52-195.086,195.086s87.52,195.086,195.086,195.086c107.574,0,195.086-87.52,195.086-195.086 S318.917,16.257,211.343,16.257z"></path> </g> <g> <g> <path style="fill:#38ba72;" d="M192.85,252.88l-0.569-7.397c-1.707-15.371,3.414-32.149,17.647-49.227 c12.811-15.078,19.923-26.182,19.923-38.985c0-14.51-9.112-24.182-27.044-24.467c-10.242,0-21.622,3.414-28.735,8.819 l-6.828-17.924c9.388-6.828,25.605-11.38,40.692-11.38c32.726,0,47.52,20.2,47.52,41.83c0,19.346-10.811,33.295-24.483,49.511 c-12.51,14.794-17.07,27.312-16.216,41.83l0.284,7.397H192.85V252.88z M186.583,292.718c0-10.526,7.121-17.923,17.078-17.923 c9.966,0,16.785,7.397,16.785,17.924c0,9.957-6.544,17.639-17.07,17.639C193.419,310.349,186.583,302.667,186.583,292.718z"></path> </g> </g> </g> </g></svg>`
  const elModalIcon = document.createElement('div')
  elModalIcon.className = `${customilyRefillModal}--icon`
  elModalIcon.innerHTML = iconRefillPopup

  const elModalCloseSvg = document.createElement('button')
  elModalCloseSvg.className = customilyRefillButtonClose
  elModalCloseSvg.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z" fill="#3B4148"></path></svg>'

  const elModal = document.createElement('div')
  elModal.className = customilyRefillModal

  const elModalTitle = document.createElement('div')
  elModalTitle.className = `${customilyRefillModal}--title`
  elModalTitle.textContent = 'Let us help save your time!'

  const elModalContent = document.createElement('div')
  elModalContent.className = `${customilyRefillModal}--content`
  elModalContent.innerHTML =
    '<p>You have a previous customization.<br> Do you want to auto-fill that customization?</p>'

  const elModalController = document.createElement('div')
  elModalController.className = `${customilyRefillModal}--controller`

  const confirmBtn = document.createElement('button')
  confirmBtn.className = `${customilyRefillButtonConfirm}`
  confirmBtn.textContent = 'Yes, go ahead'

  const closeBtn = document.createElement('span')
  closeBtn.className = customilyRefillButtonReject
  closeBtn.textContent = 'No, I want to start over again'

  elModalController.appendChild(confirmBtn)
  elModalController.appendChild(closeBtn)
  elModal.appendChild(elModalCloseSvg)
  elModal.appendChild(elModalIcon)
  elModal.appendChild(elModalTitle)
  elModal.appendChild(elModalContent)
  elModal.appendChild(elModalController)
  el.appendChild(elModal)
  document.body.appendChild(el)
  trackingRestoreCustomilyPersonalized('show')
}

function startRefillCustomilyPersonalized() {
  const storedCustomilyObject = readingStoredOptions(rawProductId.value)
  let runRefill = false

  if (storedCustomilyObject) {
    createPopup()
    const closeFillCustomilyPopupHandler = () => {
      const popupElement = document.querySelector(
        `.${customilyRefillModalWrapper}`
      )
      runRefill = false
      document.body.removeChild(popupElement)
    }
    const closeFillCusstomilyAndTrackingEvent = () => {
      closeFillCustomilyPopupHandler()
      trackingRestoreCustomilyPersonalized('reject')
    }
    const closeButton = document.querySelector(
      `.${customilyRefillButtonReject}`
    )
    const closeSvg = document.querySelector(`.${customilyRefillButtonClose}`)
    if (closeButton)
      closeButton.addEventListener('click', closeFillCusstomilyAndTrackingEvent)
    if (closeSvg)
      closeSvg.addEventListener('click', closeFillCusstomilyAndTrackingEvent)

    const confirmHandler = () => {
      closeFillCustomilyPopupHandler()
      runRefill = true
      trackingRestoreCustomilyPersonalized('restore')
      // Because when you click to agree to refill, the event listener will activate,
      // the data may be refreshed, so you need to use setTimeout here
      confirmedRestoreCustomily.value = true
      setTimeout(() => (confirmedRestoreCustomily.value = false), 2000)
    }
    const confirmBtn = document.querySelector(
      `.${customilyRefillButtonConfirm}`
    )
    if (confirmBtn) confirmBtn.addEventListener('click', confirmHandler)
  }

  const fillingCustomilyChoseItems = setInterval(() => {
    if (
      document.querySelector(
        `#${customilyOptionSelector} .customily-options-wrapper`
      ) &&
      runRefill
    ) {
      clearInterval(fillingCustomilyChoseItems)
      const storedCustomilyObject2 = readingStoredOptions(rawProductId.value)
      if (!storedCustomilyObject2) return !1
      const { properties } = storedCustomilyObject2,
        foundIds = Object.keys(properties)
          .map((i) => ({
            elId: i,
            existed: document.getElementById(i),
            value: properties[i].value,
          }))
          .filter((i) => i.value !== '')
      setTimeout(() => {
        handlePickedStoredOptions(foundIds)
      }, 500)
    }
  }, 500)
}
// end refill customily personalize function
</script>

<style lang="scss">
#customily-options {
  background-color: var(--background-color);
  border: solid 1px var(--border-color);
  border-bottom: none;
  border-radius: var(--border-radius-small) var(--border-radius-small) 0 0;
  padding: 1em;
  margin-bottom: 0 !important;
  #cl_optionsapp {
    background-color: transparent;
    border: none;
    padding: 0;
    label {
      font-size: 1em;
      font-weight: 600;
      margin: 0 0 0.5em;
      text-align: left;
      color: var(--text-color-primary);
    }
    .customily_option {
      margin-bottom: 1em !important;
      position: relative;
      &.cl-has-checkbox {
        .cl-option-content {
          left: 0;
        }
        .cl-checkbox-label {
          margin-left: 25px;
        }
      }
      input:not([type='checkbox']) {
        font-size: 16px !important;
      }
      .customily-file-input {
        .cl_remove-image {
          position: relative;
          min-height: 44px;
          border: none;
          color: #fff;
          background: var(--button-primary-bg);
          border-radius: 3px;
          &:hover {
            background: var(--button-primary-hover-bg);
            cursor: pointer;
          }
          &::after {
            content: 'Successful!';
            position: absolute;
            font-weight: 500;
            font-size: 0.85rem;
            left: 50px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--color-primary);
          }
        }
        .customily-download-button {
          font-size: 13px;
          padding: 0 10px;
          border-radius: 3px;

          // style tooltip loading for upload image customily
          &.disabled {
            &::after {
              content: 'Processing';
              position: absolute;
              width: 95px;
              font-family: 'SFProText', sans-serif;
              font-size: 0.8rem;
              color: #fff;
              background: #000;
              text-align: center;
              border-radius: 4px;
              padding: 9px;
              z-index: 1;
              top: 27px;
              left: 157px;
              text-transform: capitalize;
              line-height: 27px;
            }
            &::before {
              content: '';
              position: absolute;
              border-width: 0.4rem;
              border-style: solid;
              border-color: transparent #000 transparent transparent;
              top: 45px;
              left: 148px;
            }
            & + .cl_remove-image {
              display: none !important;
            }
          }
        }
      }
    }
  }
  ~ .product__preview-loading {
    display: none;
  }

  &:empty {
    display: none;
    ~ .customily-preview {
      display: none;
    }
    ~ .product__preview-loading {
      display: block;
    }
  }
}

.lightbox-popup {
  line-height: 0;
}

.sib-position-custom-upload-image {
  display: inline;
}

button[data-hidden-remove-image-customily='true'] {
  display: none !important;
}

.customily-preview {
  padding: 0 1em 1em 1em;
  border: solid 1px var(--border-color);
  border-top: none;
  background-color: var(--background-color);
}

.customily-preview-button {
  display: none !important;
}

#product-popup-review {
  background: transparent;
  padding: 0;
  max-width: 700px;
  .product-popup-review__canvas-wrapper {
    background: #fff;
    border-radius: 10px;
  }
  .product-popup-preview__note {
    margin: 1.5rem 0;
    p {
      margin: 0;
      text-align: center;
      &:first-child {
        font-size: 17px;
        font-weight: 600;
        @include media-md-up {
          font-size: 18px;
        }
      }
      &:nth-child(2) {
        font-size: 13px;
        @include media-md-up {
          font-size: 14px;
        }
      }
    }
  }
  .is-close {
    top: 6px;
    right: 16px;
    border-radius: 4px;
  }
  .carousel__button {
    width: 30px;
    height: 30px;
    padding: 6px;
  }
}

.product-popup-review__canvas-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 1em;
  flex-direction: column;

  #preview-canvas {
    position: initial !important;
    touch-action: auto !important;
    user-select: all !important;
  }
}

.product-popup-review__button-wrapper {
  text-align: center;
}

.button-show-preview {
  width: auto;
  font-size: 1em;
}

.sticky-button-show-preview-container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: var(--promotion-bar-z-index);
  transform: translateY(200%);
  transition: transform var(--animation-duration);
  &--fixed {
    transform: translateY(0);
  }
}

// customily loading overlay
.loadingoverlay {
  z-index: var(--customily-loading-overlay-z-index) !important;
}

// custom upload image
.customization-upload-file-wrapper,
.customization-upload-image-wrapper {
  display: inline;

  --customily-color: #9d8661;
  --white-color: #ffffff;
  --tooltip-background: #0d0c22;

  .sib-file-select-wrapper {
    display: inherit;
  }
  label.sib-file-select {
    width: auto !important;
    text-transform: uppercase;
    font-family: Dosis, sans-serif;
    margin: 0 !important;
    padding: 10px;
    height: 44px;
    letter-spacing: 1px;
    line-height: 1.8;
    border-radius: 3px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid var(--customily-color);
    color: var(--customily-color) !important;
    font-weight: normal !important;
    font-size: 13px !important;
    .sib-file-select-loading {
      color: var(--customily-color);
    }
    &:hover {
      background-color: var(--customily-color);
      color: var(--white-color) !important;
      .sib-file-select-loading {
        color: var(--white-color);
      }
    }
  }
  .delete-custom-upload-image {
    padding: 0.75rem;
    background-color: var(--color-secondary);
    border: 1px solid var(--border-color);
    svg {
      width: 1rem;
      fill: var(--white-color);
    }
  }
  .tooltip-image-processing {
    display: inline-block;
    font-size: 0.85rem;
    margin-left: 0.75rem;
    padding: 0.9rem 0.4rem;
    background: var(--tooltip-background);
    text-align: center;
    position: relative;
    border-radius: 4px;
    color: var(--white-color);
    bottom: 2px;
    &:after {
      content: '';
      position: absolute;
      border-width: 0.4rem;
      border-style: solid;
      border-color: transparent var(--tooltip-background) transparent
        transparent;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
    }
    @include media-md-up {
      padding: 0.9rem 1rem;
    }
  }
  .remove-custom-upload-image {
    margin: 0 1rem;
    padding: 14px 14px;
    border-radius: 3px;
    color: #fff;
    background: var(--button-primary-bg);
    min-width: unset;
    cursor: pointer;
    &:hover {
      background: var(--button-primary-hover-bg);
    }
  }
  .customization-upload-image-upload-title {
    font-weight: 600;
    margin-bottom: var(--space-xsmall);
  }
}
.customization-upload-image-wrapper-message {
  display: inline;
  font-weight: 500;
  font-size: 0.85rem;
  &--error {
    display: block;
    margin-top: 4px;
  }
}
.text-primary {
  color: var(--color-primary);
}
.text-secondary {
  color: var(--color-secondary);
}
.customization-title {
  font-weight: 600;
  margin-bottom: var(--space-xsmall);
}
.carousel-photo-album {
  .carousel__slide {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 800px;
      max-height: 60vh;
      width: 100%;
    }
  }
}
#product-popup-preview-photo-album {
  background: transparent;
}

.product-popup-review-photo-album__canvas-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 1em;
  flex-direction: column;
}

.product-popup-review-photo-album__button-wrapper {
  text-align: center;
}

.product-personalization-optionset-only-note {
  color: var(--color-primary);
  font-weight: 500;
}

.customily_personalized {
  &--popup_refill--modal {
    background: #fff;
    border-radius: 20px;
    left: 50%;
    padding: 2rem 1rem;
    position: fixed;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 550px;
    width: calc(100% - 2rem);
    &_wrapper {
      background: #0009;
      height: 100%;
      left: 0;
      top: 0;
      overflow: hidden;
      position: fixed;
      width: 100%;
      z-index: var(--popup-z-index);
    }
    &--icon {
      margin-top: 1rem;
    }
    &--title {
      font-size: 24px;
      @include media-md-up {
        font-size: 30px;
      }
      font-weight: bold;
      margin: 0.5rem auto;
    }
    &--content {
      margin-bottom: 1.5rem;
      font-size: 16px;
    }
    &--controller {
      display: flex;
      font-size: 16px;
      justify-content: center;
      flex-direction: column;
    }
    &--controller button {
      border-radius: var(--border-radius-medium);
      margin: auto;
      padding: 10px 0;
      width: 240px;
    }
  }
  &--popup_btn {
    font-size: 16px;
    &--confirm {
      background-color: var(--color-primary);
      color: #fff;
      border: none;
      cursor: pointer;
    }
    &--reject {
      margin-top: 1rem;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  &--poup--close_svg {
    right: 0;
    top: 0;
    border: 0;
    padding: 10px;
    position: absolute;
    width: 44px;
    background: none;
    opacity: 0.5;
    cursor: pointer;
  }
}

.customily-set-order-item .customily_option {
  order: var(--sort-order);
  margin-top: 0 !important;
}

.customily-set-order-item .customily_music_set-visibility {
  order: var(--music-order);
}

@media (max-width: 525px) {
 .panzoom__viewport {
  min-height: 300px !important;
  }
}
</style>
